import Typography from '@components/v2/ui/Typography/Typography';
import { Button, Grid } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { Form } from 'react-final-form';
import * as yup from 'yup';
import LangEnum from '../../lang/LangEnum';
import { SignatureInfo } from '../../lib/SiteLib';
import yupValidation from '../../lib/yupValidation';
import { useTranslation } from '../../modules/translation/TranslationContext';
import teceoInputConfig from '../../utils/TeceoInputConfig';
import RFFPhoneField from '../ReactFinalForms/RFFPhoneField';
import RFFTextField from '../ReactFinalForms/RFFTextField';

const validationSchema = yup.object().shape({
  email: yup.string().email().required(LangEnum.GLOBAL_REQUIRED),
});

const validate = async (values: any) => yupValidation(validationSchema)({ ...values });

type PersonSignatureFormProps = {
  loading: boolean;
  onCancel: () => void;
  onSave: (values: SignatureInfo) => Promise<void>;
  initialValues?: SignatureInfo;
};

const PersonSignatureForm = ({
  initialValues,
  loading,
  onCancel,
  onSave,
}: PersonSignatureFormProps) => {
  const onSubmit = (values: any) => {
    onSave({
      ...values,
      phone: values?.phone ? values.phone.slice(values.countryCode?.length) : undefined,
    });
  };
  const { translate } = useTranslation();

  const customItem = {
    ...initialValues,
    phone: initialValues?.phone ? `${initialValues.countryCode}${initialValues.phone}` : null,
  };

  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      initialValues={customItem}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid size={12}>
              <Typography variant="h4" color="textSecondary">
                {initialValues?.name}
              </Typography>
            </Grid>

            <Grid size={12}>
              <RFFTextField
                {...teceoInputConfig}
                autoFocus
                name="role"
                label={translate(LangEnum.GLOBAL_DEPARTMENT)}
              />
            </Grid>

            <Grid size={12}>
              <RFFTextField {...teceoInputConfig} name="email" label="e-mail" />
            </Grid>

            <Grid size={12}>
              <RFFPhoneField
                {...teceoInputConfig}
                label={translate(LangEnum.GLOBAL_TELEPHONE)}
                name="phone"
              />
            </Grid>

            <Grid size={12}>
              <Grid
                container
                spacing={2}
                sx={{
                  justifyContent: 'flex-end',
                }}
              >
                <Grid size="auto">
                  <Button disabled={loading} color="primary" onClick={onCancel}>
                    {translate(LangEnum.GLOBAL_CANCEL_LABEL)}
                  </Button>
                </Grid>

                <Grid size="auto">
                  <Button
                    disabled={loading}
                    variant="contained"
                    color="primary"
                    type="submit"
                    startIcon={loading ? <CircularProgress size={20} /> : undefined}
                  >
                    {translate(LangEnum.GLOBAL_SAVE)}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};

export default PersonSignatureForm;
